module.exports = __webpack_public_path__ + "media/images/menu/musca-711bb9ce6b441837f29538f079ffd7b3.jpg";